import { Link } from 'react-router-dom';
import type { PropsWithChildren } from 'react';
import { useAuth } from '../hooks/useAuth';

const AppShell = ({ children }: PropsWithChildren<{ title: string }>) => {
  const { user, logout } = useAuth();
  const userLabel = user?.email ?? user?.username ?? '';
  const userInitial = userLabel.charAt(0).toUpperCase() || 'U';
  const canBatchExport = Boolean(user?.canBatchExport ?? user?.can_batch_export ?? user?.isStaff ?? user?.is_staff);

  return (
    <div className="min-h-screen bg-[#f5f5f5] text-[#0f0f19]">
      <header className="border-b border-black/5 bg-white/95 backdrop-blur">
        <div className="mx-auto flex w-full max-w-none items-center justify-between px-6 py-4 lg:px-10">
          <Link to="/" className="flex items-center gap-3 text-left">
            <img src="/brand/logo-symbol-black.png" alt="gridfield" className="h-8 w-auto" />
            <span className="text-sm font-semibold uppercase tracking-[0.4em] text-[#1c1c2c]">gridfield</span>
          </Link>
          <div className="flex items-center gap-3 text-xs">
            {canBatchExport && (
              <Link
                to="/app/batch-export"
                className="rounded-full border border-black/10 px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.35em] text-[#0f0f19] transition hover:border-black/30"
              >
                Batch export
              </Link>
            )}
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-black/10 bg-[#0f0f19] text-sm font-semibold uppercase text-white">
                {userInitial}
              </span>
              <span className="hidden sm:inline font-semibold text-[#0f0f19]">{userLabel}</span>
            </div>
            <button
              type="button"
              onClick={logout}
              className="rounded-full border border-black/10 px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.35em] text-[#0f0f19] transition hover:border-black/30"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-7xl px-6 py-10 lg:px-10">
        <div>{children}</div>
      </main>
      <footer className="border-t border-black/10 bg-white py-6 text-center text-xs text-[#5a5b6c]">
        <p>© {new Date().getFullYear()} gridfield · Energy Intelligence Platform</p>
      </footer>
    </div>
  );
};

export default AppShell;
